<script>
    import {afterUpdate} from 'svelte';
    import Modal from 'svelte-simple-modal';
    import Button from "./components/Button.svelte";
    import {componentName as storeComponentName, form as formStore} from "./stores/store";

    export let componentName;

    export let iblock;
    export let formTitle;
    export let buttonText;
    export let buttonClass;
    export let fields = [];

    export let defaultData = [];
    export let event;
    export let captchaSitekey = '';

    let isReady = false;
    let isInited = false;


    afterUpdate(() => {
        if (!isInited && componentName) {
            isInited = true;
            storeComponentName.set(componentName);
            isReady = true;
            formStore.set({
                buttonText,
                buttonClass,
                fields,
                defaultData,
                captchaSitekey,
                iblock,
                event
            });
        }
    });
</script>

{#if fields.length}
    <Modal>
        <Button {formTitle} {buttonText} {buttonClass}/>
    </Modal>
{/if}